import React, { useState } from "react";
import "../../Styles/Profile.css";
import { toast } from "sonner";
import { useFormik } from "formik";
import { uploadEmployeeDocument } from "../../services/axios/apiManager";
import { profileDocsSchema } from "./profileValidations";
import { useAppContext } from "../../services/context";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";

const Education = () => {
  const navigate = useNavigate();
  const { state } = useAppContext();
  const { user } = state;
  const [loading, setLoading] = useState(true);

  const docsFormik = useFormik({
    initialValues: {
      documentName: "",
      documentType: "",
      document: null,
      remarks: "",
    },
    validationSchema: profileDocsSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("documentName", values.documentName);
        formData.append("documentType", values.documentType);
        formData.append("document", values.document);
        formData.append("remarks", values.remarks);

        const res = await uploadEmployeeDocument(user?.id, formData);
        if (res?.data?.success) {
          toast.success("Document has been Added", { duration: 2000 });
          resetForm();
        } else {
          handleErrors(res, navigate, "Documents: ");
        }
      } catch (error) {
        console.log("Error Upon Documents form", error);
      } finally {
        setLoading(false);
      }
    },
  });
  return (
    <div className="tab-pane" id="education" role="tabpanel">
      <div className="card shadow-lg border-0 rounded-2 card-header bg-dark text-white">
        <div className="card-body">
          <form>
            <div id="newlink">
              <div id={1}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">Document</label>
                      <input
                        type="file"
                        data-testid="Document"
                        className="bg-dark text-light border-light input-placeholder-light form-control"
                        placeholder="Select document"
                        onChange={(event) => {
                          docsFormik.setFieldValue(
                            "document",
                            event.currentTarget.files[0] || null
                          );
                        }}
                        onBlur={() =>
                          docsFormik.setFieldTouched("document", true)
                        }
                      />
                      {docsFormik?.errors?.document &&
                      docsFormik?.touched?.document ? (
                        <span className="text-danger">
                          {docsFormik?.errors?.document}
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">Document Name</label>
                      <input
                        type="text"
                        data-testid="Document_Name"
                        className="bg-dark text-light border-light input-placeholder-light form-control"
                        placeholder="Enter document name"
                        {...docsFormik.getFieldProps("documentName")}
                      />
                      {docsFormik?.errors?.documentName &&
                      docsFormik?.touched?.documentName ? (
                        <span className="text-danger">
                          {docsFormik?.errors?.documentName}
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">Document Type</label>
                      <select
                        className="bg-dark text-light border-light input-placeholder-light form-control"
                        {...docsFormik.getFieldProps("documentType")}
                        data-testid="Document_Type"
                      >
                        <option value="">Select type</option>
                        <option value="ID Card">ID Card</option>
                        <option value="Resume">Resume</option>
                        <option value="Passport">Passport</option>
                        <option value="Contract">Contract</option>
                      </select>
                      {docsFormik?.errors?.documentType &&
                      docsFormik?.touched?.documentType ? (
                        <span className="text-danger">
                          {docsFormik?.errors?.documentType}
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label htmlFor="degreeDescription" className="form-label">
                        Remarks
                      </label>
                      <textarea
                        data-testid="Remarks"
                        className="bg-dark text-light border-light input-placeholder-light form-control"
                        id="degreeDescription"
                        rows={3}
                        placeholder="Enter description"
                        defaultValue={""}
                      />
                    </div>
                  </div>
                  <div className="hstack gap-2 justify-content-end">
                    <button
                      type="button"
                      onClick={docsFormik.handleSubmit}
                      className="btn btn btn-success"
                    >
                      Add Document
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Education;
